// extracted by mini-css-extract-plugin
module.exports = {"modal":"dce580","modal__content":"_981dff","modal__button-close":"_2a8336","modal__text":"_541c9b","modal__icon-close":"_47ac7a"};